/** ACT004 用户信息表单热点：绑定字段（与控台 act004-user-form-fields.js 对齐） */
export const ACT004_USER_FORM_FIELD_OPTIONS = [
  { value: 'phone', label: '手机号' },
  { value: 'real_name', label: '姓名' },
  { value: 'nickname', label: '昵称' },
  { value: 'avatar', label: '头像' },
  { value: 'birthday', label: '生日' },
  { value: 'card_id', label: '身份证' },
  { value: 'company_name', label: '公司名称' },
  { value: 'employee_no', label: '员工号' },
  { value: 'channel', label: '渠道' },
  { value: 'job_title', label: '职务' },
  { value: 'need_accommodation', label: '是否需要住宿' },
  { value: 'has_companion', label: '是否有随行人员' },
  { value: 'remark', label: '备注' }
]

export const ACT004_USER_FORM_FIELD_BINDS = ACT004_USER_FORM_FIELD_OPTIONS.map((o) => o.value)

export const ACT004_FORM_RADIO_GROUP_BINDS = ['need_accommodation', 'has_companion']

export function normalizeAct004UserFormFieldBind(bind, fallback = 'phone') {
  const b = String(bind || fallback).trim().toLowerCase()
  return ACT004_USER_FORM_FIELD_BINDS.includes(b) ? b : fallback
}

export function isAct004FormRadioGroupBindField(bind) {
  const b = String(bind || '').trim().toLowerCase()
  return ACT004_FORM_RADIO_GROUP_BINDS.includes(b)
}

export function normalizeFormInputRequired(raw) {
  if (raw === false || raw === 0 || raw === '0') return 0
  return 1
}

/** 1=多行文本；0=单行。未配置时备注默认多行，其它默认单行 */
export function normalizeFormInputMultiline(raw, bind) {
  const s = String(raw == null ? '' : raw).trim().toLowerCase()
  if (raw === true || raw === 1 || raw === '1' || s === 'multi' || s === 'multiline' || s === 'textarea') {
    return 1
  }
  if (raw === false || raw === 0 || raw === '0' || s === 'single' || s === 'line' || s === 'input') {
    return 0
  }
  return String(bind || '').trim().toLowerCase() === 'remark' ? 1 : 0
}

export function normalizeFormInputPrefixIcon(raw) {
  const s = String(raw == null ? '' : raw).trim().toLowerCase()
  if (s === 'user' || s === 'phone') return s
  return 'none'
}

export function normalizeFormRadioUiStyle(raw) {
  const s = String(raw || '').trim().toLowerCase()
  if (s === 'list' || s === 'survey' || s === 'radio') return 'list'
  return 'text'
}

export function suggestAct004FormInputLabel(bind) {
  const b = String(bind || '').trim().toLowerCase()
  const map = {
    company_name: '单位名称',
    real_name: '参会人姓名',
    job_title: '职务',
    phone: '联系电话',
    need_accommodation: '是否需要住宿',
    has_companion: '是否有随行人员',
    remark: '备注',
    nickname: '昵称',
    employee_no: '员工号',
    channel: '渠道',
    birthday: '生日',
    card_id: '身份证',
    avatar: '头像'
  }
  if (map[b]) return map[b]
  return act004UserFormFieldLabel(b)
}

export function suggestAct004FormInputPrefixIcon(bind) {
  const b = String(bind || '').trim().toLowerCase()
  if (b === 'real_name' || b === 'nickname') return 'user'
  if (b === 'phone') return 'phone'
  return 'none'
}

export function normalizeAct004FormRadioLayout(raw) {
  return String(raw || '').trim().toLowerCase() === 'column' ? 'column' : 'row'
}

export function defaultAct004YesNoFormRadioOptions() {
  return [
    { value: '是', label: '是', left: null, top: null, width: null, height: null, fontSize: null },
    { value: '否', label: '否', left: null, top: null, width: null, height: null, fontSize: null }
  ]
}

export function normalizeAct004FormRadioOptions(list, opts) {
  const options = opts && typeof opts === 'object' ? opts : {}
  const layout = normalizeAct004FormRadioLayout(options.layout)
  const applyLayout = options.applyLayout === true
  const src = Array.isArray(list) ? list : []
  const out = []
  src.forEach((raw) => {
    if (!raw || typeof raw !== 'object') return
    const value = String(raw.value != null ? raw.value : raw.label || '').trim()
    const label = String(raw.label != null ? raw.label : value).trim()
    if (!value && !label) return
    const fontSizeRaw = parseInt(raw.fontSize, 10)
    const leftRaw = raw.left == null || raw.left === '' ? null : parseFloat(raw.left)
    const topRaw = raw.top == null || raw.top === '' ? null : parseFloat(raw.top)
    const widthRaw = raw.width == null || raw.width === '' ? null : parseFloat(raw.width)
    const heightRaw = raw.height == null || raw.height === '' ? null : parseFloat(raw.height)
    out.push({
      value: value || label,
      label: label || value,
      left: Number.isFinite(leftRaw) ? Math.max(0, Math.min(100, leftRaw)) : null,
      top: Number.isFinite(topRaw) ? Math.max(0, Math.min(100, topRaw)) : null,
      width: Number.isFinite(widthRaw) ? Math.max(1, Math.min(100, widthRaw)) : null,
      height: Number.isFinite(heightRaw) ? Math.max(1, Math.min(100, heightRaw)) : null,
      fontSize: Number.isFinite(fontSizeRaw) ? Math.max(12, Math.min(120, fontSizeRaw)) : null
    })
  })
  if (!applyLayout || !out.length) return out
  const n = out.length
  if (layout === 'column') {
    const h = Math.max(1, Math.floor(100 / n))
    out.forEach((opt, i) => {
      opt.left = 0
      opt.top = Math.min(100 - h, i * h)
      opt.width = 100
      opt.height = i === n - 1 ? Math.max(1, 100 - opt.top) : h
    })
  } else {
    const w = Math.max(1, Math.floor(100 / n))
    out.forEach((opt, i) => {
      opt.left = Math.min(100 - w, i * w)
      opt.top = 0
      opt.width = i === n - 1 ? Math.max(1, 100 - opt.left) : w
      opt.height = 100
    })
  }
  return out
}

export function ensureAct004FormRadioOptionsForBind(bind, list, opts) {
  if (!isAct004FormRadioGroupBindField(bind)) return []
  const normalized = normalizeAct004FormRadioOptions(list, opts)
  if (normalized.length) return normalized
  return normalizeAct004FormRadioOptions(defaultAct004YesNoFormRadioOptions(), {
    layout: opts && opts.layout,
    applyLayout: true
  })
}

export function pickAct004FormInputHotspotFields(raw) {
  const src = raw && typeof raw === 'object' ? raw : {}
  const bind = normalizeAct004UserFormFieldBind(src.userFieldBind, 'phone')
  const isRadioGroup = isAct004FormRadioGroupBindField(bind)
  const formRadioLayout = normalizeAct004FormRadioLayout(src.formRadioLayout)
  const formRadioFontSize = (() => {
    const n = parseInt(src.formRadioFontSize != null ? src.formRadioFontSize : src.formInputFontSize, 10)
    return Number.isFinite(n) ? Math.max(12, Math.min(120, n)) : 28
  })()
  const formRadioOptions = isRadioGroup
    ? ensureAct004FormRadioOptionsForBind(bind, src.formRadioOptions, { layout: formRadioLayout })
    : []
  const defaultMaxLen = bind === 'remark' ? 200 : 30
  const formRadioUiStyle = isRadioGroup
    ? normalizeFormRadioUiStyle(src.formRadioUiStyle != null ? src.formRadioUiStyle : 'list')
    : 'text'
  return {
    userFieldBind: bind,
    formInputLabel: String(src.formInputLabel || '').trim(),
    formInputHint: String(src.formInputHint || '').trim().slice(0, 200),
    formInputPlaceholder: String(src.formInputPlaceholder || '').trim(),
    formInputButtonImg: String(src.formInputButtonImg || '').trim(),
    formInputRequired: normalizeFormInputRequired(src.formInputRequired),
    formInputMultiline: isRadioGroup ? 0 : normalizeFormInputMultiline(src.formInputMultiline, bind),
    formInputPrefixIcon: normalizeFormInputPrefixIcon(src.formInputPrefixIcon),
    formInputFontSize: (() => {
      const rawFs = src.formInputFontSize != null ? src.formInputFontSize : src.dataFontSize
      const n = parseInt(rawFs, 10)
      return Number.isFinite(n) ? Math.max(12, Math.min(120, n)) : 30
    })(),
    formInputPaddingLeft: (() => {
      const n = parseInt(src.formInputPaddingLeft, 10)
      return Number.isFinite(n) ? Math.max(0, Math.min(120, n)) : 24
    })(),
    formInputMaxLength: (() => {
      const n = parseInt(src.formInputMaxLength, 10)
      return Number.isFinite(n) ? Math.max(1, Math.min(500, n)) : defaultMaxLen
    })(),
    formRadioLayout: isRadioGroup
      ? (formRadioUiStyle === 'list' ? 'column' : formRadioLayout)
      : formRadioLayout,
    formRadioFontSize,
    formRadioOptions,
    formRadioUiStyle
  }
}

export function pickAct004FormRadioHotspotFields(raw, fallbackBind = 'channel') {
  const src = raw && typeof raw === 'object' ? raw : {}
  const bind = normalizeAct004UserFormFieldBind(src.userFieldBind, fallbackBind)
  const groupKey = String(src.formRadioGroupKey || bind || fallbackBind).trim() || bind || fallbackBind
  return {
    userFieldBind: bind,
    formRadioGroupKey: groupKey,
    formRadioOptionValue: String(src.formRadioOptionValue || '').trim(),
    formRadioSelectedImg: String(src.formRadioSelectedImg || '').trim()
  }
}

export function act004UserFormFieldLabel(field) {
  const f = String(field || '').trim().toLowerCase()
  if (f === 'name') return '姓名'
  const hit = ACT004_USER_FORM_FIELD_OPTIONS.find((o) => o.value === f)
  return hit ? hit.label : field || ''
}

export function act004UserFormDraftKey(hotspot) {
  const idx = hotspot && hotspot.index != null && hotspot.index !== '' ? String(hotspot.index) : ''
  const bind = hotspot && hotspot.userFieldBind != null ? String(hotspot.userFieldBind).trim() : ''
  if (bind) return `${idx}:${bind}`
  return idx ? `idx:${idx}` : ''
}

/** type=26 / type=16 单选组按绑定字段读写草稿（同组多热点共享） */
export function act004UserFormFieldBindDraftKey(bind) {
  const b = String(bind || '').trim().toLowerCase()
  return b ? `field:${b}` : ''
}

export function readUserFormDraftByHotspot(draft, hotspot) {
  const d = draft && typeof draft === 'object' ? draft : {}
  const primary = act004UserFormDraftKey(hotspot)
  if (primary && Object.prototype.hasOwnProperty.call(d, primary)) {
    return d[primary] == null ? '' : String(d[primary])
  }
  const idx = hotspot && hotspot.index != null ? String(hotspot.index) : ''
  const legacy = idx ? `${idx}:` : ''
  if (legacy && Object.prototype.hasOwnProperty.call(d, legacy)) {
    return d[legacy] == null ? '' : String(d[legacy])
  }
  const legacyIdx = idx ? `idx:${idx}` : ''
  if (legacyIdx && Object.prototype.hasOwnProperty.call(d, legacyIdx)) {
    return d[legacyIdx] == null ? '' : String(d[legacyIdx])
  }
  return null
}

export function readUserFormFieldDraftByBind(draft, bind) {
  const d = draft && typeof draft === 'object' ? draft : {}
  const key = act004UserFormFieldBindDraftKey(bind)
  if (key && Object.prototype.hasOwnProperty.call(d, key)) {
    return d[key] == null ? '' : String(d[key])
  }
  return null
}

export function act004InputTypeForField(field) {
  const f = String(field || '').trim().toLowerCase()
  if (f === 'phone') return 'tel'
  if (f === 'birthday') return 'date'
  return 'text'
}

/** 将草稿字段规范化为 form_lead 可识别的 key */
export function normalizeAct004FormLeadFields(fields) {
  const src = fields && typeof fields === 'object' ? fields : {}
  const out = {}
  Object.keys(src).forEach((k) => {
    const key = String(k || '').trim().toLowerCase()
    if (!key) return
    out[key] = src[k] == null ? '' : String(src[k]).trim()
  })
  return out
}

export const ACT004_CONDITIONAL_JUMP_CONDITION_TYPES = [
  { value: 'PROFILE_FIELDS', label: '完善字段' },
  { value: 'CHECKIN_POINTS', label: '打卡点位' }
]

const PROFILE_FIELD_BINDS = ACT004_USER_FORM_FIELD_BINDS.slice()

export function normalizeConditionalTargetConditionType(type) {
  const t = String(type || '').trim().toUpperCase()
  return t === 'CHECKIN_POINTS' ? 'CHECKIN_POINTS' : 'PROFILE_FIELDS'
}

export function normalizeConditionalTargetCheckinIndexes(indexes) {
  const arr = Array.isArray(indexes) ? indexes : []
  const out = []
  arr.forEach((raw) => {
    const n = parseInt(raw, 10)
    if (!Number.isFinite(n) || n <= 0 || out.includes(n)) return
    out.push(n)
  })
  return out
}

export function normalizeConditionalTargetFields(fields) {
  const allowed = {}
  PROFILE_FIELD_BINDS.forEach((f) => {
    allowed[f] = true
  })
  const arr = Array.isArray(fields) ? fields : []
  const out = []
  arr.forEach((raw) => {
    const f = String(raw || '').trim().toLowerCase()
    if (!allowed[f] || out.includes(f)) return
    out.push(f)
  })
  return out
}

export function isAct004ProfileFieldsComplete(getFieldValue, fields) {
  const required = normalizeConditionalTargetFields(fields)
  if (!required.length) return false
  const getVal = typeof getFieldValue === 'function' ? getFieldValue : () => ''
  return required.every((f) => String(getVal(f) || '').trim() !== '')
}

export function evaluateConditionalJumpTarget(options) {
  const opts = options && typeof options === 'object' ? options : {}
  const type = normalizeConditionalTargetConditionType(opts.conditionType)
  if (type === 'CHECKIN_POINTS') {
    const indexes = normalizeConditionalTargetCheckinIndexes(opts.checkinIndexes)
    if (!indexes.length || typeof opts.isCheckinPointDone !== 'function') {
      return false
    }
    return indexes.every((idx) => !!opts.isCheckinPointDone(idx))
  }
  return isAct004ProfileFieldsComplete(opts.getProfileFieldValue, opts.profileFields)
}

export function normalizeConditionalTargetRule(rule) {
  if (!rule || typeof rule !== 'object') return null
  const targetPageIndex = parseInt(rule.targetPageIndex, 10)
  if (!Number.isFinite(targetPageIndex) || targetPageIndex < 0) return null
  const conditionType = normalizeConditionalTargetConditionType(rule.conditionType)
  const profileFields = normalizeConditionalTargetFields(rule.profileFields || rule.fields)
  const checkinIndexes = normalizeConditionalTargetCheckinIndexes(rule.checkinIndexes)
  if (conditionType === 'PROFILE_FIELDS' && !profileFields.length) return null
  if (conditionType === 'CHECKIN_POINTS' && !checkinIndexes.length) return null
  return {
    conditionType,
    profileFields,
    checkinIndexes,
    targetPageIndex
  }
}

export function normalizeConditionalTargetRules(source) {
  if (Array.isArray(source)) {
    return source.map((r) => normalizeConditionalTargetRule(r)).filter(Boolean)
  }
  if (!source || typeof source !== 'object') return []
  if (Array.isArray(source.conditionalTargetRules)) {
    return normalizeConditionalTargetRules(source.conditionalTargetRules)
  }
  const legacyPage = parseInt(source.conditionalTargetPageIndex, 10)
  if (!Number.isFinite(legacyPage) || legacyPage < 0) return []
  const legacy = normalizeConditionalTargetRule({
    conditionType: source.conditionalTargetConditionType,
    profileFields: source.conditionalTargetFields,
    checkinIndexes: source.conditionalTargetCheckinIndexes,
    targetPageIndex: legacyPage
  })
  return legacy ? [legacy] : []
}

export function hotspotNeedsProfileFieldsConditionalVerify(rulesSource) {
  const rules = normalizeConditionalTargetRules(rulesSource)
  return rules.some(
    (r) =>
      r.conditionType === 'PROFILE_FIELDS' &&
      Array.isArray(r.profileFields) &&
      r.profileFields.length > 0
  )
}

export function resolveConditionalTargetPageIndex(rulesSource, evaluateOptions, defaultPageIndex) {
  const parsedDefault = parseInt(defaultPageIndex, 10)
  const fallback =
    defaultPageIndex != null &&
    defaultPageIndex !== '' &&
    Number.isFinite(parsedDefault) &&
    parsedDefault >= 0
      ? parsedDefault
      : null
  const rules = normalizeConditionalTargetRules(rulesSource)
  const opts = evaluateOptions && typeof evaluateOptions === 'object' ? evaluateOptions : {}
  for (let i = 0; i < rules.length; i++) {
    const r = rules[i]
    if (
      evaluateConditionalJumpTarget({
        conditionType: r.conditionType,
        profileFields: r.profileFields,
        checkinIndexes: r.checkinIndexes,
        getProfileFieldValue: opts.getProfileFieldValue,
        isCheckinPointDone: opts.isCheckinPointDone
      })
    ) {
      return r.targetPageIndex
    }
  }
  return fallback
}
